// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__udmkP","title":"BackImages_title__37enO","images":"BackImages_images__3s2h3"};